export async function optimizeLogo(file) {
    const isAllowed =
      file &&
      file.type &&
      (file.type === "image/jpeg" || file.type === "image/png");

    if (!isAllowed) {
      throw new Error("Only JPG and PNG files are allowed.");
    }

    const objectUrl = URL.createObjectURL(file);
    const img = await new Promise((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = reject;
      i.src = objectUrl;
    });

    let targetW = img.width;
    let targetH = img.height;

    // resize only when height > 40
    if (img.height > 40) {
      const scale = 40 / img.height;
      targetW = Math.round(img.width * scale);
      targetH = 40;
    }

    const canvas = document.createElement("canvas");
    canvas.width = targetW;
    canvas.height = targetH;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, targetW, targetH);

    URL.revokeObjectURL(objectUrl);

    // Use WebP for smaller output; if you want to keep original type, swap "image/webp" to file.type
    const blob = await new Promise((res) =>
      canvas.toBlob(res, "image/webp", 0.75)
    );
    if (!blob) throw new Error("Failed to encode logo.");

    const base64 = await new Promise((res, rej) => {
      const fr = new FileReader();
      fr.onload = () => res(fr.result);
      fr.onerror = rej;
      fr.readAsDataURL(blob);
    });

    return base64; // data:image/webp;base64,....
  }